import { CIcon } from '~/icons/types'

export const ciBathroom: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M22.617 13.637a1.2 1.2 0 0 0-.869-.374h-.57V3.78a2.524 2.524 0 0 0-4.234-1.863l-.326.326a2.82 2.82 0 0 0-2.167-.276 2.859 2.859 0 0 0-1.28.75l-.179.18a1.192 1.192 0 0 0 0 1.69l2.343 2.345a1.194 1.194 0 0 0 1.692 0l.178-.178A2.846 2.846 0 0 0 17.68 3.3l.292-.294a1.025 1.025 0 0 1 1.706.77v9.486h-5.6v-.135a1.64 1.64 0 0 0-1.638-1.638H8.006a1.639 1.639 0 0 0-1.637 1.638v.132H2.251a1.191 1.191 0 0 0-1.191 1.265 8.743 8.743 0 0 0 8.72 8.226h4.439a8.75 8.75 0 0 0 8.722-8.224 1.211 1.211 0 0 0-.324-.89ZM16.18 5.656l-1.912-1.914a1.334 1.334 0 0 1 1.843-.02c.014.017.019.038.035.054.016.016.037.02.053.035.149.159.256.352.314.562a1.357 1.357 0 0 1-.333 1.283Zm-8.311 7.472a.137.137 0 0 1 .137-.138h4.437a.138.138 0 0 1 .138.138V17.7H7.869v-4.572Zm6.35 8.122H9.78a7.244 7.244 0 0 1-7.2-6.49h3.789v3.248A1.194 1.194 0 0 0 7.562 19.2h5.324a1.2 1.2 0 0 0 1.2-1.194v-3.243h7.335a7.245 7.245 0 0 1-7.202 6.487Z'
    },
    {
      d:
        'M9.863 5.824a.741.741 0 0 0 .313-.07l1.612-.742a.75.75 0 0 0-.628-1.362l-1.612.743a.75.75 0 0 0 .315 1.43Zm4.598 4.82a.752.752 0 0 0 .985-.395l.7-1.632a.75.75 0 1 0-1.379-.59l-.7 1.632a.75.75 0 0 0 .394.985Zm-3.182-2.132a.748.748 0 0 0 1.06.006L13.6 7.27a.751.751 0 1 0-1.054-1.07l-1.261 1.252a.75.75 0 0 0-.006 1.06Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'bathroom',
  type: 'light'
}
